export const useRelationOverviewStyles = (isSmallScreen) => {
    return {
        container: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        tabs: {
            gap: 0.5,
            '& .MuiTabs-list': {
                gap: 0.5
            }
        },
        tab: {
            color: (theme) => theme.palette.grey[700],
            '&.Mui-selected': {
                color: (theme) => theme.palette.primary.darker
            }
        },
        headerSection: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: (theme) => theme.spacing(1.5)
        },
        activityContent: {
            display: 'flex',
            flexDirection: 'column',
            height: isSmallScreen ? 'auto' : 'calc(100dvh - 235px)',
            overflow: 'auto',
            gap: (theme) => theme.spacing(1.5)
        },
        emptyState: {
            fontSize: '16px',
            color: (theme) => theme.palette.grey[500],
            textAlign: 'center'
        }
    };
};
